import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-balloon-svg',
	standalone: true,
	imports: [],
	templateUrl: './balloon-svg.component.html',
	styleUrl: './balloon-svg.component.scss',
})
export class BalloonSvgComponent {
	@Input() color!: string;

	currentColor: string = '#000000';
}
